import {
  isValidUserName
} from "../../util/Validators";

export const loginFormValidationInitialState = {
  usernameOrEmailError: false,
  usernameOrEmailErrMsg: "",
  passwordError: false,
  passwordErrMsg: "",
  isFormValid: true
}

export const LoginFormValidationReducer = (state, action) => {
    if (!action.payload){
      return state;
    }
    let isValid = false;
    switch (action.type) {
      case "VALIDATE_USERNAMEOREMAIL":
        let { usernameOrEmail } = action.payload;
        isValid = (usernameOrEmail.length > 0 && isValidUserName(usernameOrEmail));
        let userErrMsg = "User Id invalid";
        return {
          ...state,
          ...({ usernameOrEmailError: !isValid, usernameOrEmailErrMsg:userErrMsg, isFormValid: isValid && !state.passwordError })
        }
      case "VALIDATE_PASSWORD":
        let { password } = action.payload;
        isValid = password.length >= 8 ? true : false;
        let pwdErrMsg = "Password cannot be blank";
        return {
          ...state,
          ...({ passwordError: !isValid, passwordErrMsg: pwdErrMsg, isFormValid: isValid && !state.usernameOrEmailError })
        }
      default:
        return state
    }
  }



